import { useEffect, useState } from "react";
import type { ReceiptAttachment } from "../../lib/image-data";
import type { MooMessage } from "../../types/moo";
import Modal from "../../components/Modal";
const EMPTY_PHOTOS: ReceiptAttachment[] = [];

export default function MooMessagePhotos({ chatId, message, local = EMPTY_PHOTOS }: {
  chatId: string; message: MooMessage; local?: ReceiptAttachment[];
}) {
  const [urls, setUrls] = useState<string[]>([]);
  const [selected, setSelected] = useState<number | null>(null);
  useEffect(() => {
    const next = local.map(photo => URL.createObjectURL(photo.file));
    setUrls(next);
    return () => next.forEach(url => URL.revokeObjectURL(url));
  }, [local]);
  const stored = message.payload.attachments || [];
  const count = stored.length || urls.length;
  const source = (page: number, thumbnail = false) => stored.length
    ? `/api/moo/image?${new URLSearchParams({ chatId, messageId: message.id, page: String(page), ...(thumbnail ? { size: "thumb" } : {}) })}`
    : urls[page];
  if (!count) return null;
  return <>
    <div className="moo-message-photos">
      {Array.from({ length: count }, (_, page) => <button key={page} onClick={() => setSelected(page)} aria-label={`Open receipt photo ${page + 1}`}>
        <img src={source(page, true)} alt={`Receipt photo ${page + 1}`} />
      </button>)}
    </div>
    {selected !== null && <div onKeyDownCapture={event => {
      if (event.key === "Escape") { event.preventDefault(); setSelected(null); }
    }}><Modal title={`Receipt photo ${selected + 1}`} onClose={() => setSelected(null)} className="moo-photo-viewer">
      <img src={source(selected)} alt={`Receipt photo ${selected + 1}`} />
    </Modal></div>}
  </>;
}
